import { ENV } from '../environment'; 
import getCourseQuery from './queries/courseQuery';
import getFileQuery from './queries/fileQuery';
import getPatchAssignmentMutation from './queries/patchAssignmentMutation';
import getPageViewMutation from './queries/pageViewMutation';
import formatCourseForLocale from './courseDataFormatter';

const COURSE_SERVICE_ENDPOINT = `https://${ ENV }api.biw.cloud/v1/learning-exp/graphql`;

export const STATUS = {
    ASSIGNED: 'ASSIGNED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED'
};

const buildRequest = ( token, query ) => {
    return {
        method: 'POST',  
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ token }` 
        },
        body: query
    };
};

export const fetchCourse = async ( token, courseId, locale ) => {
    try {
        const response = await fetch( COURSE_SERVICE_ENDPOINT, 
            buildRequest( token, getCourseQuery( { courseId: courseId } ) ) );
    
        const responseData = await response.json();
        
        if ( responseData?.data?.course ) {
            return {
                success: true,
                course: formatCourseForLocale( responseData?.data?.course, locale )
            };
        } else {
            return {
                success: false
            };
        }
    } catch ( error ) {
        console.error( 'Error loading course', error );

        return { 
            success: false,
        };
    }    
};

export const fetchFile = async ( token, fileID ) => {
    try {
        const response = await fetch( COURSE_SERVICE_ENDPOINT, 
            buildRequest( token, getFileQuery( { lxpFileID: fileID } ) ) );

        const responseData = await response.json();
        
        if ( responseData?.data?.lxpFile?.node?.signedUrl ) {
            return {
                success: true,
                fileURL: responseData.data.lxpFile.node.signedUrl 
            };
        } else {
            return {
                success: false
            };
        }
    } catch ( error ) {
        console.error( 'Error loading file', error );

        return { 
            success: false,
        };
    }    
};

export const patchAssignment = async ( token, input ) => {
    try {
        const response = await fetch( COURSE_SERVICE_ENDPOINT, 
            buildRequest( token, getPatchAssignmentMutation( input ) ) );

        const responseData = await response.json();
        
        if ( responseData.data?.result?.status ) {
            return {
                success: true 
            };
        } else {
            return {
                success: false
            };
        }
    } catch ( error ) {
        console.error( 'Error patching assignment', error );

        return { 
            success: false,
        };
    }    
};

export const logPageView = async ( token, input ) => {
    try {
        const response = await fetch( COURSE_SERVICE_ENDPOINT, 
            buildRequest( token, getPageViewMutation( input ) ) );

        const responseData = await response.json();
        
        if ( responseData.data?.logPageView?.success ) {
            return {
                success: true 
            };
        } else {
            return {
                success: false
            };
        }
    } catch ( error ) {
        console.error( 'Error in logPageView', error );

        return { 
            success: false,
        };
    }    
};
